import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, CheckCircle } from "@phosphor-icons/react";
import { WORKFLOW_STEPS } from "@/data/content";

export function DemoNav({ name, sector }) {
    return (
        <header className="fixed inset-x-0 top-0 z-[90] border-b border-white/10 bg-black/70 backdrop-blur-2xl" data-testid="demo-nav">
            <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 md:px-10">
                <Link to="/" className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-white" data-testid="demo-back-link">
                    <ArrowLeft size={15} /> HIGHTS Demo Centre
                </Link>
                <div className="text-center">
                    <p className="font-display text-base font-black tracking-[0.15em] text-white">{name}</p>
                    <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-white/40">{sector}</p>
                </div>
                <span className="hidden border border-white/20 px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.25em] text-white/60 sm:block">
                    Live working demo
                </span>
            </div>
        </header>
    );
}

export function WorkflowStrip({ active }) {
    return (
        <div className="border border-white/12 bg-void p-6" data-testid="workflow-strip">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
                {active ? "The automated journey — happening now" : "The automated journey — submit an enquiry to see it run"}
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
                {WORKFLOW_STEPS.map((step, i) => (
                    <div key={step} className="flex items-center gap-2">
                        <motion.span
                            initial={false}
                            animate={active ? { backgroundColor: "#ffffff", color: "#000000", borderColor: "#ffffff" } : {}}
                            transition={{ delay: active ? i * 0.55 : 0, duration: 0.4 }}
                            className="flex items-center gap-2 border border-white/15 px-3.5 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-white/45"
                            data-testid={`workflow-step-${i}`}
                        >
                            {active && <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: i * 0.55 }}><CheckCircle size={13} weight="fill" /></motion.span>}
                            {step}
                        </motion.span>
                        {i < WORKFLOW_STEPS.length - 1 && <span className="text-white/25">↓</span>}
                    </div>
                ))}
            </div>
            {active && (
                <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: WORKFLOW_STEPS.length * 0.55 }}
                    className="mt-4 text-xs font-light text-white/50"
                >
                    In a live HIGHTS build, every step above runs automatically — the enquiry is answered, qualified,
                    logged in the CRM, booked and followed up without anyone lifting a finger.
                </motion.p>
            )}
        </div>
    );
}

export function DemoFooter({ name }) {
    return (
        <footer className="border-t border-white/10 bg-void py-12">
            <div className="mx-auto max-w-[1400px] px-5 text-center md:px-10">
                <p className="text-sm font-light text-white/50">
                    {name} is a fictional business built by <Link to="/" className="font-bold text-white hover:underline">HIGHTS</Link> to demonstrate a connected growth system.
                </p>
                <p className="mt-3 text-xs font-light text-white/35">
                    Enquiries submitted in this demo genuinely enter the HIGHTS CRM. AI conversations are simulated.
                </p>
                <Link to="/book" className="mt-6 inline-block border border-white/25 px-8 py-3 text-[11px] font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-white hover:text-black" data-testid="demo-footer-cta">
                    Build this for my business
                </Link>
            </div>
        </footer>
    );
}
